import CryptoJS from 'crypto-js';
export class ProductService {
    cachedProductsKey = "git_products";
    productApi;
    authService;
    constructor(api, authService) {
        this.productApi = api;
        this.authService = authService;
    }
    fetchProducts() {
        return this.productApi.getProducts().then((products) => {
            return products.filter((product) => {
                return !product.navigation_link.includes("/services/");
            });
        });
    }
    fetchProductReviewAvatar(src, progressCallback, imageLoadCallback) {
        this.productApi.getProductReviewAvatar(src, progressCallback, (data) => {
            if (!data) {
                imageLoadCallback(undefined);
                return;
            }
            const imgUrl = URL.createObjectURL(data);
            imageLoadCallback(imgUrl);
        });
    }
    getProducts() {
        const sessionKey = this.authService.getSessionKey();
        if (!sessionKey) {
            return;
        }
        return this.getCachedSessionProducts(sessionKey);
    }
    storeProducts(products) {
        const sessionKey = this.authService.getSessionKey();
        if (!sessionKey) {
            return;
        }
        this.saveSessionProducts(products, sessionKey);
    }
    getCachedSessionProducts(sessionKey) {
        const storedProducts = sessionStorage.getItem(this.cachedProductsKey);
        if (!storedProducts) {
            return undefined;
        }
        const bytes = CryptoJS.AES.decrypt(storedProducts, sessionKey);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    }
    saveSessionProducts(products, sessionKey) {
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(products), sessionKey).toString();
        sessionStorage.setItem(this.cachedProductsKey, encryptedData);
    }
}
